//引入
import { JSEncrypt } from 'jsencrypt'
/**
 * 加密
 * @param {String}  需要加密的参数
 */
export function passwordEncryption (param) {
  // 后台给的公钥
  let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCUzSD3msUGvBK46QQLlPVkMxBJbAzWOOe22/DrnLYao6t/JcKWu1hfHz3jEQ/ZQ05FD8ifzutNyWao5H7h7UY0Z7rUXRGQ5cviXyzGfelLxTDTkNaEsx+7O1rw0t72Is6IE9pWhAMEeH5nGKjK6sn80oUVlz1nSznHZZDHwfRSMQIDAQAB'
  let encryptor = new JSEncrypt() // 新建JSEncrypt对象
  encryptor.setPublicKey(publicKey) // 设置公钥
  let passwordEncryp = encryptor.encrypt(param) // 对密码进行加密
  return passwordEncryp
}

// 解密
export function decrypt (msg) {
  const privateKey = ''
  let decrypt = new JSEncrypt()
  decrypt.setPrivateKey(privateKey)
  var decryptMsg = decrypt.decrypt(msg)
  return decryptMsg
}
